import http from "../plugins/axios";
import { AxiosError } from "axios";
import { COSCredentials } from "../cos/credentials";

export interface FileUploadCredentials extends COSCredentials {
  file_key: string;
}
export interface SubmitFileModel {
  name: string;
  hashname: string;
  version: string;
}
export type SubmitStatus = "waiting" | "judging" | "finished" | "error";
export interface SubmitModel {
  status: SubmitStatus;
  submit_time: string;
  judge_info: string;
  file_keys: SubmitFileModel[];
  score: number;
  id: number;
}
export function fetchGetProblemsToken(
  token: string,
  contestId: number,
  trackId: number,
  stageId: number,
  problemId: number
): Promise<FileUploadCredentials> {
  return new Promise((resolve, reject) => {
    http
      .get(
        `/api/competition/${contestId}/track/${trackId}/stage/${stageId}/problem/${problemId}/token`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      )

      .then((response) => {
        return resolve(response.data as FileUploadCredentials);
      })
      .catch((error: AxiosError) => {
        if (error.response) {
          const status = error.response.status;
          if (status === 401) return reject("token-invalid");
          else if (status === 404) return reject("unknown-page");
          else if (status === 400) return reject("400-turn-to-admin");
          else if (status === 500) return reject("500-turn-to-admin");
          else return reject("unknown-turn-to-admin");
        } else return reject("unknown-turn-to-admin");
      });
  });
}

export function submit(
  token: string,
  contestId: number,
  trackId: number,
  stageId: number,
  problemId: number,
  fileKeys: SubmitFileModel[],
  opensource:string
): Promise<void> {
  return new Promise((resolve, reject) => {
    http
      .post(
        `/api/competition/${contestId}/track/${trackId}/stage/${stageId}/problem/${problemId}/submit`,
        { file_keys: fileKeys/*,opensource: opensource */},
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      )

      .then(() => {
        return resolve();
      })
      .catch((error: AxiosError) => {
        if (error.response) {
          const status = error.response.status;
          const reason = error.response.data;
          //改为输出信息
          if (status === 401) return reject(reason);
          if (status === 403) return reject(reason);
          else if (status === 404) return reject(reason);
          else if (status === 400) return reject(reason);
          else if (status === 500) return reject(reason);
          else return reject("unknown-turn-to-admin");
        } else return reject("unknown-turn-to-admin");
      });
  });
}

export function submitgit(
  token: string,
  contestId: number,
  trackId: number,
  stageId: number,
  problemId: number,
  fileKeys: SubmitFileModel[],
  opensource:string
): Promise<void> {
  return new Promise((resolve, reject) => {
    http
      .post(
        `/api/competition/${contestId}/track/${trackId}/stage/${stageId}/problem/${problemId}/submitgit`,
        { file_keys: fileKeys/*,opensource: opensource */},
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      )

      .then(() => {
        return resolve();
      })
      .catch((error: AxiosError) => {
        if (error.response) {
          const status = error.response.status;
          const reason = error.response.data;
          //改为输出信息
          if (status === 401) return reject(reason);
          if (status === 403) return reject(reason);
          else if (status === 404) return reject(reason);
          else if (status === 400) return reject(reason);
          else if (status === 500) return reject(reason);
          else return reject("unknown-turn-to-admin");
        } else return reject("unknown-turn-to-admin");
      });
  });
}

export function fetchTeamSubmission(
  token: string,
  contestId: number,
  trackId: number,
  stageId: number,
  problemId: number
): Promise<SubmitModel[]> {
  return new Promise((resolve, reject) => {
    http
      .get(
        `/api/competition/${contestId}/track/${trackId}/stage/${stageId}/problem/${problemId}/submit`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      )
      .then((response) => {
        return resolve(
          response.data.data.map((x: SubmitModel) => {
            x.file_keys = JSON.parse(x.file_keys as unknown as string);
            return x;
          })
        );
      })
      .catch((error: AxiosError) => {
        if (error.response) {
          const status = error.response.status;
          if (status === 401) return reject("token-invalid");
          else if (status === 404) return reject("unknown-page");
          else if (status === 400) return reject("400-turn-to-admin");
          else if (status === 500) return reject("500-turn-to-admin");
          else return reject("unknown-turn-to-admin");
        } else return reject("unknown-turn-to-admin");
      });
  });
}
